// TODO 后续根据需要具体定义
export type sessionStoreKey = string;
export type localStoreKey = "encoo_locale";

export const sessionStore = {
  // eslint-disable-next-line @typescript-eslint/ban-types
  set: (key: localStoreKey, item: string | object): void => {
    const storeValue = typeof item === "string" ? item : JSON.stringify(item);
    sessionStorage.setItem(key, storeValue);
  },
  // eslint-disable-next-line @typescript-eslint/ban-types
  get: (key: localStoreKey): string | object | null => {
    const storeValue = sessionStorage.getItem(key);
    try {
      if (storeValue && typeof JSON.parse(storeValue) == "object") {
        return JSON.parse(storeValue);
      } else {
        return storeValue;
      }
    } catch (e) {
      return storeValue;
    }
  },
  remove: (key: localStoreKey): void => {
    sessionStorage.removeItem(key);
  },
  clear: (): void => {
    sessionStorage.clear();
  },
};

export const localStore = {
  // eslint-disable-next-line @typescript-eslint/ban-types
  set: (key: localStoreKey, item: string | object): void => {
    const storeValue = typeof item === "string" ? item : JSON.stringify(item);
    localStorage.setItem(key, storeValue);
  },
  // eslint-disable-next-line @typescript-eslint/ban-types
  get: (key: localStoreKey): string | object | null => {
    const storeValue = localStorage.getItem(key);
    try {
      if (storeValue && typeof JSON.parse(storeValue) == "object") {
        return JSON.parse(storeValue);
      } else {
        return storeValue;
      }
    } catch (e) {
      return storeValue;
    }
  },
  remove: (key: localStoreKey): void => {
    localStorage.removeItem(key);
  },
  clear: (): void => {
    localStorage.clear();
  },
};
